import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const ExternalDatabaseRecap = ({
 server,
 database,
 port,
 uploadLimit,
 host
}: {
 server: string;
 database: string;
 port: number;
 uploadLimit: number;
 host: string;
}): ReactElement => {
 return (
  <Paper
   elevation={1}
   sx={{
    p: 2,
    maxHeight: 580,
    position: "sticky",
    borderRadius: "5px",
    top: 20
   }}>
   <Stack textAlign="left">
    <Typography variant="unboundedTitle" fontWeight="bold" fontSize={18}>
     <FormattedMessage id="utility.externalDatabases.add.recap" />
    </Typography>
   </Stack>
   <Divider sx={{ my: 1 }} />
   <Stack textAlign="left" mb={1}>
    <Typography variant="unboundedTitle" fontSize={14}>
     <FormattedMessage id="utility.externalDatabases.add.serverData" />
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={150} textAlign="start" fontWeight="bold">
     <FormattedMessage id="utility.externalDatabases.add.serverName" />:
    </Typography>
    <Typography variant="subtitle2" noWrap>
     {server}
    </Typography>
   </Stack>
   <Divider sx={{ my: 1 }} />
   <Stack textAlign="left" mb={1}>
    <Typography variant="unboundedTitle" fontSize={14}>
     <FormattedMessage id="utility.externalDatabases.add.databaseSpecs" />
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={150} textAlign="start" fontWeight="bold">
     <FormattedMessage id="utility.externalDatabases.add.databaseName" />:
    </Typography>
    <Typography variant="subtitle2" noWrap>
     {database}
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={150} textAlign="start" fontWeight="bold">
     <FormattedMessage id="utility.externalDatabases.add.port" />:
    </Typography>
    <Typography variant="subtitle2" noWrap>
     {port}
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={150} textAlign="start" fontWeight="bold">
     <FormattedMessage id="utility.externalDatabases.add.uploadLimit" />:
    </Typography>
    <Typography variant="subtitle2" noWrap>{`${uploadLimit} MB`}</Typography>
   </Stack>
   <Stack direction="row" spacing={2} alignItems="center">
    <Typography variant="subtitle2" minWidth={150} textAlign="start" fontWeight="bold">
     <FormattedMessage id="utility.externalDatabases.add.databaseHost" />
    </Typography>
    <Typography variant="subtitle2" noWrap>
     {host}
    </Typography>
   </Stack>
  </Paper>
 );
};

export default ExternalDatabaseRecap;
